var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.filterName,
    staticClass: "filter text-body-2",
    "class": {
      search: _vm.filter.type == 'search',
      embedded: _vm.embedded
    }
  }, [_vm.filter.type == 'search' || !_vm.filter.type ? [_c('v-text-field', {
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.filter.focus,
      "background-color": _vm.backgroundColor,
      "disabled": _vm.filter.disabled,
      "label": _vm.filter.label,
      "placeholder": _vm.placeHolder,
      "prepend-inner-icon": _vm.iconName('search'),
      "value": _vm.value,
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "single-line": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event || null);
      }
    }
  })] : _vm.filter.type == 'country' ? [_c('CountrySelect', {
    ref: "dropdownControl",
    "class": {
      active: _vm.isActive,
      filter: true
    },
    attrs: {
      "value": _vm.value,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm._f("flattenChoices")(_vm.choices),
      "label": _vm.filterLabel,
      "loading": _vm.loading,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "dense": true,
      "flat": true,
      "hide-details": true,
      "outlined": true
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event || null);
      }
    }
  })] : ['float', 'integer'].indexOf(_vm.filter.type) != -1 ? [_c('v-combobox', {
    ref: "dropdownControl",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm._f("flattenChoices")(_vm.choices),
      "label": _vm.filterLabel,
      "loading": _vm.loading,
      "menu-props": _vm.dropdownMenuProps,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "value": _vm.value,
      "type": "number",
      "dense": "",
      "flat": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event || null);
      }
    }
  })] : _vm.filter.type == 'input' || _vm.filter.type == 'string' ? [_c('v-combobox', {
    ref: "dropdownControl",
    staticClass: "autocomplete",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm._f("flattenChoices")(_vm.choices),
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "menu-props": _vm.dropdownMenuProps,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "value": _vm.value,
      "dense": "",
      "flat": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event);
      }
    }
  })] : _vm.filter.type == 'boolean' ? [_c('v-checkbox', {
    key: _vm.value,
    staticClass: "text-body-2 mt-0 checkbox",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "background-color": _vm.backgroundColor,
      "disabled": _vm.filter.disabled,
      "input-value": !!_vm.value || false,
      "label": _vm.filter.label,
      "name": _vm.filterName,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "single-line": ""
    },
    on: {
      "change": _vm.booleanInputChanged
    }
  })] : _vm.filter.type == 'formatselect' ? [_c('FormatSelect', {
    ref: "dropdownControl",
    "class": ['format-filter-select', {
      active: _vm.isActive
    }],
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "value": _vm.value,
      "formats": _vm.formatRecords,
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "variant": "grouped",
      "show-custom-option": false,
      "show-create-option": false,
      "clearable": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event || null);
      }
    }
  })] : _vm.filter.type == 'select' && _vm.filter.multiple ? [_c('v-autocomplete', {
    ref: "dropdownControl",
    staticClass: "autocomplete",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm.choices,
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "menu-props": _vm.dropdownMenuProps,
      "multiple": _vm.filter.multiple,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "value": _vm.value,
      "no-data-text": _vm.$translate('noDataAvailable'),
      "dense": "",
      "flat": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var _vm$value;
        var index = _ref.index,
          item = _ref.item;
        return [index == 0 ? [_vm.filter.multiple ? [((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.length) > 1 ? _c('span', {
          staticStyle: {
            "font-size": "9pt"
          }
        }, [_vm._v(" " + _vm._s(_vm.$translate("items").replace("{count}", _vm.nbItems)) + " ")]) : [_c('span', {
          staticStyle: {
            "font-size": "9pt"
          }
        }, [_vm._v(" " + _vm._s(item.text) + " ")])]] : [_c('span', {
          staticStyle: {
            "font-size": "9pt"
          }
        }, [_vm._v(" " + _vm._s(item.text) + " ")])]] : _vm._e()];
      }
    }])
  })] : _vm.filter.type == 'combo' || _vm.filter.type == 'select' && !_vm.filter.multiple ? [_c('v-select', {
    ref: "dropdownControl",
    staticClass: "combobox",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm.choices,
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "menu-props": _vm.dropdownMenuProps,
      "multiple": _vm.filter.multiple,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "value": _vm.value,
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "flat": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event);
      }
    }
  })] : _vm.filter.type == 'searchselect' ? [_c('v-autocomplete', {
    ref: "dropdownControl",
    staticClass: "autocomplete",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.embeddedAutofocus,
      "background-color": _vm.backgroundColor,
      "clearable": !_vm.filter.defaultLabel && _vm.filter.clearable != false,
      "disabled": _vm.filter.disabled,
      "items": _vm.choices,
      "label": _vm.filter.label,
      "placeholder": _vm.filter.placeholder || undefined,
      "loading": _vm.loading,
      "menu-props": _vm.dropdownMenuProps,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon),
      "required": _vm.filter.required,
      "search-input": _vm.search,
      "value": _vm.value,
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "flat": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event);
      },
      "update:search-input": _vm.updateSearch
    }
  })] : _vm.filter.type == 'searchprovider' ? [_c('SearchProvider', {
    ref: "dropdownControl",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "value": _vm.value,
      "background-color": _vm.backgroundColor,
      "flat": "",
      "dense": "",
      "outlined": "",
      "label": _vm.filter.label,
      "disabled": _vm.filter.disabled,
      "icon": _vm.filter.icon,
      "loading": _vm.loading,
      "hide-details": true,
      "autofocus": _vm.embeddedAutofocus,
      "load-on-mount": _vm.embedded,
      "menu-props": _vm.dropdownMenuProps
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event === null || $event === void 0 ? void 0 : $event.id);
      }
    }
  })] : _vm.filter.type == 'searchcustomer' ? [_c('SearchCustomer', {
    ref: "dropdownControl",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "value": _vm.value,
      "background-color": _vm.backgroundColor,
      "flat": "",
      "dense": "",
      "outlined": "",
      "label": _vm.filter.label,
      "disabled": _vm.filter.disabled,
      "icon": _vm.filter.icon,
      "loading": _vm.loading,
      "hide-details": true,
      "autofocus": _vm.embeddedAutofocus,
      "load-on-mount": _vm.embedded,
      "menu-props": _vm.dropdownMenuProps
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event === null || $event === void 0 ? void 0 : $event.id);
      }
    }
  })] : _vm.filter.type == 'datetime' ? [_c('DateTime', {
    staticClass: "autocomplete",
    "class": {
      active: _vm.isActive
    },
    attrs: {
      "autofocus": _vm.filter.focus,
      "background-color": _vm.backgroundColor,
      "clearable": _vm.filter.clearable != false,
      "dense": true,
      "disabled": _vm.filter.disabled,
      "fixed": false,
      "flat": true,
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "min-date": null,
      "outlined": true,
      "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon || 'date'),
      "required": _vm.filter.required,
      "value": _vm.value,
      "hide-details": true
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('change', $event);
      }
    }
  })] : _vm.filter.type == 'daterange' ? [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-y": "",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "text-body-2",
          "class": {
            active: _vm.hasRange
          },
          attrs: {
            "background-color": _vm.hasRange ? 'primary-lighter2' : 'secondary',
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon || 'date'),
            "value": _vm.rangeLabel,
            "label": _vm.filter.label,
            "placeholder": _vm.filter.placeholder || _vm.filter.label,
            "clearable": ""
          },
          on: {
            "click:clear": _vm.clearRange
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.rangeMenu,
      callback: function callback($$v) {
        _vm.rangeMenu = $$v;
      },
      expression: "rangeMenu"
    }
  }, [_c('v-card', [_vm.filter.dateRangePresets ? _c('div', {
    staticClass: "filter__date-range-presets"
  }, _vm._l(_vm.datePresetChoices, function (code) {
    return _c('v-btn', {
      key: code,
      "class": ['text-none filter__date-range-preset', {
        'filter__date-range-preset--active': _vm.selectedPreset === code
      }],
      attrs: {
        "x-small": "",
        "text": ""
      },
      on: {
        "click": function click($event) {
          return _vm.selectPreset(code);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.datePresetLabel(code)) + " ")]);
  }), 1) : _vm._e(), _c('v-date-picker', {
    attrs: {
      "range": "",
      "color": "primary",
      "scrollable": "",
      "no-title": ""
    },
    model: {
      value: _vm.pickerRange,
      callback: function callback($$v) {
        _vm.pickerRange = $$v;
      },
      expression: "pickerRange"
    }
  }), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": _vm.cancelRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeClose")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "text": "",
      "disabled": !_vm.isRangeComplete
    },
    on: {
      "click": _vm.applyRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeApply")) + " ")])], 1)], 1)], 1)] : _vm.filter.type == 'numberrange' ? [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-y": "",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "text-body-2",
          "class": {
            active: _vm.hasRange
          },
          attrs: {
            "background-color": _vm.hasRange ? 'primary-lighter2' : 'secondary',
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "prepend-inner-icon": _vm.filterIcon(_vm.filter.icon || 'euro'),
            "value": _vm.numberRangeLabel,
            "label": _vm.filter.label,
            "placeholder": _vm.filter.placeholder || _vm.filter.label,
            "clearable": ""
          },
          on: {
            "click:clear": _vm.clearRange
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.rangeMenu,
      callback: function callback($$v) {
        _vm.rangeMenu = $$v;
      },
      expression: "rangeMenu"
    }
  }, [_c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "min-width": "280"
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": _vm.$translate('numberRangeMin'),
      "suffix": _vm.filter.unit
    },
    model: {
      value: _vm.pickerMin,
      callback: function callback($$v) {
        _vm.pickerMin = $$v;
      },
      expression: "pickerMin"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": _vm.$translate('numberRangeMax'),
      "suffix": _vm.filter.unit
    },
    model: {
      value: _vm.pickerMax,
      callback: function callback($$v) {
        _vm.pickerMax = $$v;
      },
      expression: "pickerMax"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-0 pb-0"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": _vm.cancelRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeClose")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "text": "",
      "disabled": !_vm.hasNumberRangeInput
    },
    on: {
      "click": _vm.applyNumberRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeApply")) + " ")])], 1)], 1)], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }